import React from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';

const VideoBackground = ({ src, fallbackImage, children, overlay = true }) => {
  const { colors } = useTheme();

  const containerStyles = {
    position: 'relative',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
  };

  const videoStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    minWidth: '100%',
    minHeight: '100%',
    width: 'auto',
    height: 'auto',
    transform: 'translate(-50%, -50%)',
    zIndex: -2,
    objectFit: 'cover',
  };

  const overlayStyles = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: colors.overlay || 'rgba(0, 0, 0, 0.3)',
    zIndex: -1,
    transition: 'background-color 0.3s ease',
  };

  const contentStyles = {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    color: '#ffffff',
  };

  return (
    <div style={containerStyles}>
      <video style={videoStyles} autoPlay muted loop playsInline poster={fallbackImage}>
        <source src={src} type="video/mp4" />
        {fallbackImage && <img src={fallbackImage} alt="" style={videoStyles} />}
      </video>
      {overlay && <div style={overlayStyles} />}
      <div style={contentStyles}>{children}</div>
    </div>
  );
};

export default VideoBackground;
